import { createErrorHandler } from "./handling-errors-base";

export const errorMessages: { [key: number]: string } = {
  401: "Error de token",
  404: "Error userId no encontrado",
};

export const handlingCollegeErrors = createErrorHandler(errorMessages);
